import { render } from "./InstallerTasks.vue?vue&type=template&id=2d9c1a11&scoped=true"
import script from "./InstallerTasks.vue?vue&type=script&lang=js"
export * from "./InstallerTasks.vue?vue&type=script&lang=js"

import "./InstallerTasks.vue?vue&type=style&index=0&id=2d9c1a11&lang=scss&scoped=true"

import exportComponent from "/home/runner/work/orangehrm/orangehrm/installer/client/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-2d9c1a11"]])

export default __exports__